import Drawer from 'common/components-v2/modal/Drawer';
import { useUI } from 'common/context/UIContext';
import { Flex } from '@motili/ui';
import LegacyUnmetRequirementsModal from './UnmetRequirementsModal-Legacy';

const UnmetRequirementsModal = ({
    handleClose,
    unmetRequirementsList,
    UnmetRequirementsHeader,
    isOpen,
}: UnmetRequirementsModalProp) => {
    return (
        <Drawer
            drawerStyle={{
                width: '45%',
            }}
            onClose={handleClose}
            title={<span style={{ fontSize: '21px', fontWeight: '600'}}>Photo Requirements</span>}
            showClose
            open={isOpen}
        >
            <Flex style={{ marginBottom: '20px', fontWeight: '600', marginLeft: '-4px' }}>
                {UnmetRequirementsHeader()}
            </Flex>
            <Flex style={{ fontSize: '12px', fontWeight: '700' }}>
                PHOTO REQUIREMENTS
            </Flex>
            {unmetRequirementsList}
        </Drawer>
    );
};

interface UnmetRequirementsModalProp {
    handleClose: () => void;
    unmetRequirementsList: any;
    UnmetRequirementsHeader: () => string;
    isOpen: boolean;
}

const UnmetRequirementsModalWrapper = (props: UnmetRequirementsModalProp) => {
    const { isLegacyUI } = useUI();
    return isLegacyUI ? (
        <LegacyUnmetRequirementsModal {...props} />
    ) : (
        <UnmetRequirementsModal {...props} />
    );
};
export default UnmetRequirementsModalWrapper;
export { UnmetRequirementsModal };
